import { MILESTONES_GROUP } from 'kadro-helpers/lib/helpers';

export const getMilestones = groupNames => {
  const groupNamesToUse = groupNames || Object.keys(MILESTONES_GROUP);

  return [...new Set(groupNamesToUse.flatMap(group => MILESTONES_GROUP[group.toUpperCase()]))];
};
